import { useCallback, useEffect, useState } from "react";
import { type DataRequest, fetchDataRequests } from "../../../../api/dataRequests";
import { errorMessage } from "../../../../errors";

/** The person's data requests: `null` while loading, with the load error and a way to fetch them again. */
export function useDataRequests(): { requests: DataRequest[] | null; loadError: string | null; reload: () => void } {
  const [requests, setRequests] = useState<DataRequest[] | null>(null);
  const [loadError, setLoadError] = useState<string | null>(null);

  const reload = useCallback(() => {
    setLoadError(null);
    fetchDataRequests()
      .then(setRequests)
      .catch((err: unknown) => setLoadError(errorMessage(err, "We couldn't load your requests.")));
  }, []);

  useEffect(reload, [reload]);

  return { requests, loadError, reload };
}
